import React from 'react';
import styled from 'styled-components';
import axios from 'axios';
import { jsPDF } from 'jspdf';
import { I18n } from 'react-redux-i18n';
import { saveAs } from 'file-saver';
import { toJpeg } from 'html-to-image';
import { Button as AntButton, Dropdown } from 'antd';
import {
  DownloadOutlined,
  FileExcelOutlined,
  FileImageOutlined,
  FilePdfOutlined,
  FilePptOutlined,
  UserOutlined
} from '@ant-design/icons';

import { getAuthToken } from 'actions/auth';
import store from 'store';
import getEnvVariable from 'utils/env';
import get from 'lodash/get';
import DownloadPreparationModal from 'components/DownloadPreparationModal';

const Container = styled.div`
  z-index: 2;
`;

// TODO: Refactor this component
// clean the package file from old lib

class ExportButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showDownloadModal: false
    };
  }

  transformStyle(node) {
    const { colors } = this.props;

    node.style.width = '100%';
    node.style.padding = '40px';

    if (node.querySelectorAll('.legend-line-icon') && colors) {
      node.querySelectorAll('.legend-line-icon').forEach((icon, index) => {
        icon.style.color = colors[index];
      });
    }
    if (node.querySelectorAll('.recharts-text recharts-cartesian-axis-tick')) {
      node.querySelectorAll('.recharts-cartesian-axis-tick').forEach((icon) => {
        icon.style.fontFamily = 'Helvetica, sans-serif';
        icon.style.fontSize = '11px';
        icon.style.fill = '#2B3D54';
      });
    }

    if (
      node.querySelectorAll(
        '.recharts-yAxis .recharts-cartesian-axis-tick-value'
      )
    ) {
      node
        .querySelectorAll('.recharts-yAxis .recharts-cartesian-axis-tick-value')
        .forEach((label) => {
          if (label.textContent === '80') {
            label.style.display = 'none';
          }
        });
    }

    if (node.querySelectorAll('.recharts-label-list')) {
      node.querySelectorAll('.recharts-label-list').forEach((label) => {
        label.style.fontFamily = 'Helvetica, sans-serif';
        label.style.fontSize = '11px';
        label.style.fill = 'white';
      });
    }
    if (node.querySelectorAll('.recharts-legend-wrapper') && colors) {
      node
        .querySelectorAll('.recharts-legend-wrapper > itemContainer')
        .forEach((icon, index) => {
          icon.style.color = colors[index];
        });
    }
    if (node.querySelectorAll('.recharts-reference-line')) {
      node.querySelectorAll('.recharts-reference-line').forEach((label) => {
        label.style.fontFamily = 'Helvetica, sans-serif';
        label.style.fontWeight = 'bold';
        label.style.fontSize = '14px';
        label.style.fill = '#e25d34';
      });
    }

    if (node.querySelector('.recharts-label-list')) {
      if (this.props.showLabels) {
        const [X, y, width, height] = node
          .querySelector('.recharts-surface')
          .attributes.viewBox.value.split(' ');
        const newHeight = parseFloat(height) * 1.15;
        const newViewBox = `${parseFloat(X)} ${parseFloat(y) - 25} ${parseFloat(
          width
        )} ${newHeight}`;

        node
          .querySelector('.recharts-surface')
          .setAttribute('height', newHeight);
        node
          .querySelector('.recharts-surface')
          .setAttribute('viewBox', newViewBox);
        if (node.querySelector('.recharts-label-list')) {
          node.querySelector('.recharts-label-list').style.display = 'block';
        } else {
          node.querySelector('.recharts-label-list').style.display = 'none';
        }
      }
    }
  }

  async getJPGUrl() {
    const documentTargetElement = document.querySelector(
      this.props.targetElement
    );
    const node = documentTargetElement.cloneNode(true);

    this.transformStyle(node);

    const filter = (node) => {
      const exclusionClasses = ['ignored-export'];
      return !exclusionClasses.some(
        (classname) => node.classList && node.classList.contains(classname)
      );
    };

    this.setState({ loading: true });

    const url = await toJpeg(documentTargetElement, {
      quality: 0.95,
      filter: filter
    });

    const getImageDimensions = async (file) => {
      return new Promise(function (resolved) {
        var i = new Image();
        i.onload = function () {
          resolved({
            width: i.width,
            height: i.height
          });
        };
        i.src = file;
      });
    };

    const { width, height } = await getImageDimensions(url);

    this.setState({ loading: false });
    return { url, width, height };
  }

  exportPdf() {
    this.getJPGUrl().then(({ url, width, height }) => {
      const orientation = this.props.pdfOrientation || 'portrait';
      const pageWidth = orientation === 'portrait' ? 210 : 297;
      const pageHeight = orientation === 'portrait' ? 297 : 210;
      const ratio = (height * 1.12) / width;
      let imgWidth = pageWidth;
      let imgHeight = pageWidth * ratio;

      if (imgHeight > pageHeight) {
        imgHeight = pageHeight;
        imgWidth = pageHeight / ratio;
      }

      const doc = new jsPDF({
        orientation
      });

      doc.addImage(url, 'JPEG', 0, 0, imgWidth, imgHeight);
      doc.save(`${this.props.name}.pdf`);
    });
  }

  exportJPG() {
    this.getJPGUrl().then(({ url }) => {
      this.saveAs(url, `${this.props.name}.jpg`);
    });
  }

  saveAs(uri, filename) {
    var link = document.createElement('a');

    if (typeof link.download === 'string') {
      link.href = uri;
      link.download = filename;
      //Firefox requires the link to be in the body
      document.body.appendChild(link);
      //simulate click
      link.click();
      //remove the link when done
      document.body.removeChild(link);
    } else {
      window.open(uri);
    }
  }

  async exportXls(name, path, options) {
    const reactAppApiUrl = getEnvVariable('REACT_APP_API_URL');
    const reactAppApiNewUrl = getEnvVariable('REACT_APP_API_NEW_URL');

    // Show download preparation modal
    this.setState({ showDownloadModal: true });

    try {
      let token = await getAuthToken();
      const clientToken = store.getState().auth.clientToken;
      if (clientToken) {
        token = clientToken;
      }
      let url = (this.props.newApi ? reactAppApiNewUrl : reactAppApiUrl) + path;
      if (options) {
        Object.keys(options).forEach((optionUrl) => {
          let lastChar = url.substr(url.length - 1);
          if (options[optionUrl] || options[optionUrl] === false) {
            url = `${url}${lastChar === '/' ? '?' : '&'}${optionUrl}=${
              options[optionUrl]
            }`;
          }
        });
      }
      const response = await axios({
        headers: {
          Authorization: `Token ${token}`
        },
        responseType: 'blob',
        url: url,
        method: 'GET'
      });
      const blob = new Blob([response.data], {
        type: 'application/vnd.ms-excel'
      });

      // Hide modal after download is ready
      this.setState({ showDownloadModal: false });

      if (response.headers['content-disposition']) {
        const headersName = response.headers['content-disposition']
          .split(`filename="`)[1]
          .split(`"`)[0];
        return saveAs(blob, headersName);
      }

      return saveAs(blob, name ? name + '.xls' : 'file.xls');
    } catch (error) {
      // Hide modal on error
      this.setState({ showDownloadModal: false });
      throw error;
    }
  }

  async exportPpt(name, path, options) {
    const reactAppApiUrl = getEnvVariable('REACT_APP_API_URL');
    const reactAppApiNewUrl = getEnvVariable('REACT_APP_API_NEW_URL');

    let token = await getAuthToken();
    const clientToken = store.getState().auth.clientToken;
    if (clientToken) {
      token = clientToken;
    }
    let url = (this.props.newApi ? reactAppApiNewUrl : reactAppApiUrl) + path;
    if (options) {
      Object.keys(options).forEach((optionUrl) => {
        let lastChar = url.substr(url.length - 1);
        if (options[optionUrl]) {
          url = `${url}${lastChar === '/' ? '?' : '&'}${optionUrl}=${
            options[optionUrl]
          }`;
        }
      });
    }
    const response = await axios({
      headers: {
        Token: `Token ${token}`
      },
      responseType: 'blob',
      url: url,
      method: 'GET',
      maxRedirects: 0
    });

    const blob = new Blob([response.data], {
      type: 'application/vnd.ms-powerpoint'
    });

    if (response.headers['content-disposition']) {
      const headersName = response.headers['content-disposition']
        .split(`filename="`)[1]
        .split('.')[0];
      return saveAs(blob, headersName + '.ppt');
    }
    const requestUrl = decodeURI(response.request.responseURL);
    if (requestUrl.includes('s3.amazon')) {
      let fileName = requestUrl.split('?')[0].split('/').slice(-1)[0];
      return saveAs(blob, fileName);
    }

    return saveAs(blob, name ? name + '.ppt' : 'file_1.ppt');
  }

  getEnabledOptions() {
    if (this.props.customOptions) {
      return this.props.customOptions;
    }

    const optionsDownload = [
      {
        key: 'xls',
        label: I18n.t('export') + ' XLS',
        icon: <FileExcelOutlined style={{ fontSize: 20 }} />,
        onAction: () =>
          this.exportXls(this.props.name, this.props.path, this.props.options)
      },
      {
        key: 'xlsx',
        label: I18n.t('export') + ' XLSX',
        icon: <FileExcelOutlined style={{ fontSize: 20 }} />,
        onAction: () =>
          this.exportXls(this.props.name, this.props.path, this.props.options)
      },
      {
        key: 'pdf',
        label: I18n.t('export') + ' PDF',
        icon: <FilePdfOutlined style={{ fontSize: 20 }} />,
        onAction: () => this.exportPdf()
      },
      {
        key: 'jpg',
        label: I18n.t('export') + ' JPG',
        icon: <FileImageOutlined style={{ fontSize: 20 }} />,
        onAction: () => this.exportJPG()
      },
      {
        key: 'ppt',
        label: I18n.t('export') + ' PPT',
        icon: <FilePptOutlined style={{ fontSize: 20 }} />,
        onAction: () =>
          this.exportPpt(
            this.props.name,
            this.props.pathPpt,
            this.props.options
          )
      },
      {
        key: 'assistant',
        label: 'Mon assistant personnalisé',
        icon: <UserOutlined style={{ fontSize: 20 }} />,
        onAction: () => alert('assistant')
      }
    ];
    return optionsDownload.filter((item) =>
      Object.keys(this.props).includes(item.key)
    );
  }

  render() {
    const downloadOptions = this.getEnabledOptions();
    const enabledOptions = downloadOptions.map((option) => ({
      key: option.key,
      icon: get(option, 'icon'),
      disabled: get(option, 'disabled', false),
      label: (
        <a style={{ fontFamily: 'SFCompactText' }} onClick={option.onAction}>
          {option.label}
        </a>
      )
    }));

    return (
      <Container>
        <div className="containerExportButton ignored-export">
          <Dropdown
            menu={{ items: enabledOptions }}
            disabled={get(this.props, 'disabled', false)}
          >
            <AntButton
              type="primary"
              className="secondary"
              shape="circle"
              icon={<DownloadOutlined style={{ fontSize: 16 }} />}
              loading={this.state.loading || get(this.props, 'loading', false)}
              disabled={this.state.loading || get(this.props, 'loading', false)}
            />
          </Dropdown>
        </div>
        <DownloadPreparationModal open={this.state.showDownloadModal} />
      </Container>
    );
  }
}

export default ExportButton;
